export const nav = {
    "nav_dashboard": "Dashboard",
    "nav_files": "File List",
    "nav_available_tutors": "Available Tutors",
    "nav_working_hours": "Working Hours",
    "nav_class": "Class",
    "nav_my_homework": "My Homework",
    "nav_homeworkBank": "Homework Bank",
    "nav_grade_pending": "Pending Grading",
};

export const weekday = {
    "weekday_1": "Monday",
    "weekday_2": "Tuesday",
    "weekday_3": "Wednesday",
    "weekday_4": "Thursday",
    "weekday_5": "Friday",
    "weekday_6": "Saturday",
    "weekday_7": "Sunday",
    "weekday_Workdays": "Workdays",
    "weekday_Weekends": "Weekends",
};

export const userRoles = {
    "role_tutor": "Tutor",
    "role_super_admin": "SuperAdmin",
    "role_academic_tutor": "Academic Tutor",
    "role_manager_admin": "Manager Admin",
    "role_admin": "Admin",
    "role_consultant": "Consultant",
    "role_student": "Student",
};

export const common = {
    "loading": "Loading...",
    "_BaseTitle": "UniTop",
    ...nav,
    ...weekday,
    ...userRoles,
};
